<template>
    <v-app>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title pt-3 px-3 d-flex justify-content-between">
                            <div class="breadcrumb-left">
                                <h4> Scan QR Code</h4>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <v-row>
                            <v-col
                                cols="12"
                                md="10"
                            >
                                <v-text-field
                                    outlined
                                    dense
                                    ref="inputField"
                                    label="Search by OR Code"
                                    v-model="userEnrollmentInfo.qr_code"
                                    v-on:keyup.enter="searchEnrollmentInfos()"
                                ></v-text-field>
                                <span class="text-danger" v-if="$v.userEnrollmentInfo.qr_code.$error">This information is required</span>
                            </v-col>

                            <v-col cols="12" md="2" class="text-right">
                                <v-btn 
                                    :loading="loading" 
                                    @click="searchEnrollmentInfos()"
                                    class="btn btn-primary w-35" 
                                    dark
                                >
                                    <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                                    Search
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-row v-if="userInfo">
                            <v-col cols="12">
                                <div class="" v-if="!userNotFound">
                                    <table class="table" v-if="!loading">
                                        <thead>
                                            <tr class="px-3">
                                                <th class="px-3 wrap-column">Student info</th>
                                                <th class="px-3 wrap-column">Status</th>
                                                <th class="pr-3 text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="px-3 wrap-column">
                                                    <div>
                                                        {{ userInfo.full_name }}
                                                    </div>
                                                    <div class="mt-2">
                                                        <strong>{{ userInfo.symbol_no ? userInfo.symbol_no : 'NA'  }}</strong>
                                                    </div>
                                                </td>

                                                <td class="px-3 wrap-column">
                                                    <span class="badge badge-warning" v-if="userInfo.exam_status == 'pending'">
                                                        {{ userInfo.exam_status ? userInfo.exam_status_text : 'NA'  }}
                                                    </span>
                                                    <span class="badge badge-success" v-if="userInfo.exam_status == 'attended'">
                                                        {{ userInfo.exam_status ? userInfo.exam_status_text : 'NA'  }}
                                                    </span>
                                                    <span class="badge badge-danger" v-if="userInfo.exam_status == 'not_attended'">
                                                        {{ userInfo.exam_status ? userInfo.exam_status_text : 'NA'  }}
                                                    </span>
                                                </td>

                                                <td class="pr-0 text-center">
                                                    <b-dropdown size="sm" variant="link"
                                                        toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                                                        no-caret right no-flip>
                                                        <template v-slot:button-content>
                                                            <slot>
                                                                <span>
                                                                    <i class="flaticon-more-1"></i>
                                                                </span>
                                                            </slot>
                                                        </template>
                                                        <!--begin::Navigation-->
                                                        <div class="navi navi-hover ">
                                                            <b-dropdown-text tag="div" class="navi-item" v-if="userInfo.exam_status == 'pending' || userInfo.exam_status == 'not_attended'">
                                                                <a href="#" class="navi-link" @click="markAsAttended(userInfo.id)">
                                                                    <span class="navi-icon">
                                                                        <i class="fa fa-check-circle"></i>
                                                                    </span>
                                                                    <span class="navi-text"> Mark as attended </span>
                                                                </a>
                                                            </b-dropdown-text>

                                                            <b-dropdown-text tag="div" class="navi-item" v-if="userInfo.exam_status == 'pending' || userInfo.exam_status == 'attended'">
                                                                <a href="#" class="navi-link" @click="markAsNotAttended(userInfo.id)">
                                                                    <span class="navi-icon">
                                                                        <i class="fa fa-times-circle"></i>
                                                                    </span>
                                                                    <span class="navi-text"> Mark as not attended </span>
                                                                </a>
                                                            </b-dropdown-text>
                                                        </div>
                                                    </b-dropdown>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <div v-if="userNotFound">
                                    <span class="text-danger"> No records found </span>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
        </div>
    </v-app>
</template>

<script>
    import UserEnrollmentInfoService from '@/core/services/kiosk/user-enrollment-info/UserEnrollmentInfoService';
    import { required } from "vuelidate/lib/validators";

    const userEnrollmentInfo = new UserEnrollmentInfoService();

    export default {
        validations:{
            userEnrollmentInfo:{
                qr_code: {required}
            }
        },
        data(){
            return {
                userEnrollmentInfo:{
                    qr_code: null
                },
                userInfo: '',
                loading:false,
                userNotFound: false,
            }
        },
        mounted(){
            this.setFocusTextField();
        },
        methods:{
            searchEnrollmentInfos(){
                this.$v.userEnrollmentInfo.$touch();
                if (this.$v.userEnrollmentInfo.$error) {
                    setTimeout(() => {
                        this.$v.userEnrollmentInfo.$reset();
                    }, 3000);
                } else {
                    this.loading = true;
                    this.userInfo = null;
                    this.userNotFound = false;

                    userEnrollmentInfo
                    .findByQrCode(this.userEnrollmentInfo.qr_code)
                    .then(res => {
                        this.userInfo = res.data.userEnrolmentInfo;
                        if(res.data.userEnrolmentInfo == null){
                            this.userNotFound = true;
                            setTimeout(()=>{
                                this.userNotFound = false;
                            }, 5000)
                        }
                    })
                    .catch((err) => {

                    })
                    .finally(() => {
                        this.loading = false;
                    });
                }
            },

            markAsAttended(id){
                this.$confirm({
                    message: `Are you sure you want to mark as attended?`,
                    button: {
                        no: "No",
                        yes: "Yes",
                    },
                    callback: (confirm) => {
                    if (confirm) {
                        userEnrollmentInfo
                        .markAsAttended(id)
                        .then((response) => {
                            this.$snotify.success("Marked as attended");
                            this.searchEnrollmentInfos();
                        })
                        .catch((err) => {
                            this.$snotify.error(
                            "Something went wrong. Please try again later!!"
                            );
                        });
                    }
                    },
                });
            },

            markAsNotAttended(id){
                this.$confirm({
                    message: `Are you sure you want to mark as not attended?`,
                    button: {
                        no: "No",
                        yes: "Yes",
                    },
                    callback: (confirm) => {
                    if (confirm) {
                        userEnrollmentInfo
                        .markAsNotAttended(id)
                        .then((response) => {
                            this.$snotify.success("Marked as not attended");
                            this.searchEnrollmentInfos();
                        })
                        .catch((err) => {
                            this.$snotify.error(
                            "Something went wrong. Please try again later!!"
                            );
                        });
                    }
                    },
                });
            },

            setFocusTextField(){
                this.$nextTick(() => {
                    this.$refs.inputField.focus();
                });
            }
        }
    }
</script>

<style scoped>
    .wrap-column{
        max-width: 100px !important; 
        white-space: pre-wrap;
    }
</style>